module.exports = __webpack_public_path__ + "media/images/img_woman-c4d64d1d5d7a4c1f86622f22c6228794.png";